<template>
	<div class="bcgl">
		<div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
			<el-card class="box-card">
				<div slot="header">
					<el-row style="margin-bottom: 20px">
						<el-col :span="24">
							<div style="line-height: 3rem; font-size: 2rem;">装备类型管理</div>
						</el-col>

					</el-row>
					<el-row style="text-align: left">
						<el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData()">
							<el-form-item>
								<el-input v-model="searchForm.name" @change="changeIndex" placeholder="类型" clearable></el-input>
							</el-form-item>
							<el-form-item>
								<el-button @click="searchData()">查询</el-button>
								<el-button v-if="isAuth('equiptype:add')" type="primary" @click="showMessageType()" icon="el-icon-plus" style="display: inline;">添加</el-button>
								<el-button v-if="isAuth('equiptype:delete')"  type="danger" @click="deleteHandle()">批量删除
								</el-button>
							</el-form-item>
						</el-form>
					</el-row>
				</div>

				<el-table
						@selection-change="selectionChangeHandle"
						:header-cell-class-name="handleHeaderClass"
						@sort-change="handleTableSort"
						:data="messageTypeList" v-loading="loading" style="text-align: center; width: 100%;">
					<el-table-column
							type="selection"
							header-align="center"
							align="center"
							width="50">
					</el-table-column>

					<el-table-column prop="name" label="品名">
					</el-table-column>
					<el-table-column prop="specification" label="规格">
					</el-table-column>
					<el-table-column prop="unit" label="计量单位">
					</el-table-column>
					<el-table-column prop="price" label="单价" sortable="custom">
					</el-table-column>
					<el-table-column  label="库存" prop="inventory" sortable="custom">
					</el-table-column>
					<el-table-column  label="更新年限(年)" prop="useTime" sortable="custom">
					</el-table-column>
					<el-table-column  label="使用年限" prop="useterm" sortable="custom">
					</el-table-column>
					<el-table-column  label="状态" prop="status" sortable="custom" >
						<template slot-scope="scope">
							<span v-if=" scope.row.status === '1'" style="color: red">已注销</span>
							<span v-else style="color: green">正常</span>
							</template>
					</el-table-column>
					<el-table-column label="操作" width="150" :render-header="renderHeader">
						<template slot-scope="scope">
							<i v-if="isAuth('equiptype:update')" class="el-icon-edit-outline" style="font-size: 20px;margin: 0px 4px;cursor: pointer;" :title="scope.row.status === '1'?'取消注销':'注销'" @click="logOutType(scope.row.id,scope.row.status === '1'?'0':'1')"></i>
							<i v-if="isAuth('equiptype:update')" class="el-icon-edit" style="font-size: 20px;margin: 0px 4px;cursor: pointer;" title="修改" @click="showMessageType(scope.row)"></i>
							<i v-if="isAuth('equiptype:delete')" class="el-icon-delete" style="font-size: 20px;margin: 0px 4px;cursor: pointer;" title="删除" @click="deleteHandle(scope.row.id)"></i>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
				 :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
				</el-pagination>
			</el-card>
		</div>



		<el-dialog :title="this.messageDate.id?'修改装备类型':'保存装备类型'" :visible.sync="showbmxxVisible" width="30%">
			<el-form  style="text-align:left;margin: 10px 80px 10px 30px" ref="form" :model="messageDate" :rules="dataRule" label-width="100px">
				<el-form-item prop="name" label="品名">
					<el-input v-model="messageDate.name"></el-input>
				</el-form-item>
				<el-form-item prop="specification" label="规格">
					<el-input  placeholder="规格" v-model="messageDate.specification" ></el-input>
				</el-form-item>
				<el-form-item label="单位" prop="unit" >
					<el-input placeholder="单位" v-model="messageDate.unit" ></el-input>
				</el-form-item>
				<el-form-item label="单价" prop="price" >
					<el-input placeholder="单价"   v-model="messageDate.price" ></el-input>
				</el-form-item>
				<el-form-item label="库存" prop="inventory" >
					<el-input placeholder="库存"   v-model="messageDate.inventory" ></el-input>
				</el-form-item>
				<el-form-item label="更新年限(年)" prop="useTime" >
					<el-input placeholder="使用年限"   v-model="messageDate.useTime" ></el-input>
				</el-form-item>
				<el-form-item label="使用年限" prop="useterm">
					<el-date-picker
							v-model="messageDate.useterm"
							type="date"
							value-format="yyyy-MM-dd HH:mm:ss"
							placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="类型" prop="type" >
					<el-select v-model="messageDate.type">
						<el-option :key="1" :value="1" label="春秋服装"></el-option>
						<el-option :key="5" :value="5" label="夏季服装"></el-option>
						<el-option :key="6" :value="6" label="冬季服装"></el-option>
						<el-option :key="2" :value="2" label="鞋子"></el-option>
						<el-option :key="3" :value="3" label="帽子"></el-option>
						<el-option :key="4" :value="4" label="其他"></el-option>

					</el-select>
				</el-form-item>
				<el-form-item label="排序号" prop="orderNum">
					<el-input-number  v-model="messageDate.orderNum" controls-position="right" :min="0" label="排序号"></el-input-number>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showbmxxVisible = false">取 消</el-button>
				<el-button type="primary" @click="savebmxx()">保 存</el-button>
			</span>
		</el-dialog>

		<el-dialog
				style="text-align: left"
				title="导出"
				:visible.sync="exportVisible"
		>
			<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
			<el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
				<el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
			</el-checkbox-group>
			<form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/equip/type/exportExcel?access_token='+this.$store.getters.token"  target="_blank">
				<input type="hidden" v-for="(value,key,index) in searchForm" :name="key"  :value="value" />
				<input type="hidden" name="fileds" value="" ref="fileds"/>
			</form>
			<span slot="footer" class="dialog-footer">
    <el-button @click="exportVisible = false">取 消</el-button>
    <el-button type="primary" @click="exportExcel">确 定</el-button>
  </span>
		</el-dialog>
	</div>
</template>
<script>
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	const exportFields=[
		{value:"name",name:"名称"},
		{value:"specification",name:"规格"},
		{value:"unit",name:"单位"},
		{value:"price",name:"单价"},
		{value:"inventory",name:"库存"},
		{value:"useTime",name:"更新年限"},
		{value:"useterm",name:"使用年限"},
		{value:"type",name:"类型"},
		{value:"status",name:"状态"}
	]
	@Component({
		name: 'bmgl'
	})
	export default class bmgl extends Vue {
		messageTypeList = [];
		messageDate = {
			useTime:'',
			id:'',
			name:'',
			orderNum:0,
			specification:'',
			unit:'',
			price:'',
			inventory:'',
			type:'',
			useterm:''
		};
		currentNo = 1;
		pageSize = 10;
		pageTotal = 0;
		showbmxxVisible= false;
		orders=[];
		searchForm= {
			name: '',
			orders:''
		}
		loading = false;
		dataListSelections=[];
		sjbm=[]
		selectBm=''
		dataRule={
			name: [
				{required: true, message: '类型名称不能为空', trigger: 'blur'}
			],
			orderNum: [
				{required: true, message: '排序号不能为空', trigger: 'blur'}
			],
			unit:[
				{required: true, message: '单位不能为空', trigger: 'blur'}
			],
			type:[
				{required: true, message: '请选择类型', trigger: 'blur'}
			],
			price: [{
				required: true,
				trigger: 'blur',
				message: '请输入单价',
			},{validator:this.validateNumber,trigger: 'blur'}],
			useTime:[{validator:this.validateNumber,trigger: 'blur'}]
		}
		isIndeterminate=false
		exportVisible=false
		checkAll=false
		fields=exportFields
		filedValues=exportFields.map(item => item.value)
		fieldList=[]
		created() {
			this.searchData();
		}

		 validateNumber (rule, value, callback)  {
			if(value) {
				var patrn = /^\d+(\.\d+)?$/;
				if (!patrn.exec(value)) {
					callback(new Error('请填写数字'))
				} else {
					callback()
				}
			} else callback()
		}
		handleSizeChange(val) {
			this.pageSize = val;
			this.searchData();
		}
		handleCurrentChange(val) {
			this.currentNo = val;
			this.searchData();
		}
		changeIndex() {
			this.currentNo =1
		}
		getParams() {
			this.searchForm.page = this.currentNo
			this.searchForm.pagesize = this.pageSize
			this.searchForm.orders = encodeURI(JSON.stringify(this.orders))
		}
		searchData() {
			this.getParams()
			this.loading = true;
			this.$request({
					url: '/bjba/equip/type/page',
					method: 'get',
					params: this.searchForm
				})
				.then(response => {
					this.loading = false;
					console.log(response);
					let data = response.data;
					if (data.code == 200) {
						this.messageTypeList = data.data.content;
						this.pageTotal = data.data.totalElements
					} else {
						this.$message.error(data.message)
					}
				})
				.catch(error => {
					this.loading = false;
					console.log(error)
					this.$message.error(msg)
				});
		}
		// 多选
		selectionChangeHandle (val) {
			this.dataListSelections = val
		}

		// 设置列的排序为我们自定义的排序
		handleHeaderClass({ column }) {
			if(!column.multiOrder) column.multiOrder =''
			column.order = column.multiOrder
		}
		handleOrderChange (orderColumn, orderState) {
			let result = this.orders.find(e => e.orderColumn === orderColumn)
			if (result) {
				if(orderState)
					result.orderState = orderState
				else {
					var j =this.orders.indexOf(result);
					if(j !== -1) {
						this.orders.splice(j,1);
					}
				}
			} else {
				this.orders.push({
					orderColumn: orderColumn,
					orderState: orderState
				})
			}
			this.searchData()
		}
// 上面缺点是只能通过点击表头切换排序状态，点击小三角排序不会触发，处理sort-change事件和点击表头一样
// 列表排序
		handleTableSort({ column }) {
			console.log(column.orderfield)
			column.multiOrder = column.order
			this.handleOrderChange(column.property, column.multiOrder)
		}
		handleCheckAllChange(val) {
			this.fieldList = val ? this.filedValues: [];
			this.isIndeterminate = false;
		}
		handleCheckedItemChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.filedValues.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
		}
		showExportDialog() {
			this.exportVisible = true
		}
		renderHeader (h) {
			return (
					<div class="clearfix">
							<span>操作</span>
							<el-button style="padding:5px;float:right" size="mini"
			onClick={()=>this.showExportDialog()}>导出</el-button></div>
		)
		}
		exportExcel() {
			var filedLast = this.fields.filter(filed=>{
				return this.fieldList.indexOf(filed.value) !==-1
			})
			if(filedLast && filedLast.length>0) {
				this.getParams();
				this.$refs.fileds.value = JSON.stringify(filedLast)
				this.$refs.exportForm.submit();
			} else {
				this.$message({
					message: '请选择字段',
					type: 'error',
					duration: 1500
				})
				return
			}
		}
		showMessageType(val) {
			// this.messageDate = { ...val };
			if(val) {
				this.messageDate.id = val.id;
				this.messageDate.name = val.name;
				this.messageDate.orderNum = val.orderNum;
				this.messageDate.specification = val.specification
				this.messageDate.unit = val.unit
				this.messageDate.price = val.price
				this.messageDate.inventory = val.inventory
				this.messageDate.useTime = val.useTime
				this.messageDate.type = val.type
			}else {
				this.messageDate.id = '';
				this.messageDate.name = '';
				this.messageDate.orderNum = 0;
				this.messageDate.specification = ''
				this.messageDate.unit = ''
				this.messageDate.price = ''
				this.messageDate.inventory = ''
				this.messageDate.useTime = ''
				this.messageDate.type = ''
			}
			this.showbmxxVisible = true;
		}
		savebmxx(bmxx) {
			this.$refs['form'].validate((valid) => {
			if(valid) {
				this.$request({
					url: '/bjba/equip/type/save',
					method: 'post',
					data: this.messageDate
				})
						.then(response => {
							console.log(response);
							let data = response.data;
							if (data.code == 200) {
								this.$message({
									message: '操作成功',
									type: 'success',
									duration: 1500
								})
								this.showbmxxVisible = false;
								this.searchData();
							} else {
								this.$message.error(data.message)
							}

						})
						.catch(error => {
							console.log(error)
							this.$message.error(msg)
						});
			}
			})


		}
		deleteHandle (id) {
			let ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			if(!ids || ids.length==0) return
			this.$confirm(`确定进行[删除]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/bjba/equip/type/delete`,
					method: 'post',
					data: ids
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.searchData()
					} else if(data && data.code ==500) {
						this.$message({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}

		/**
		 * 类型注销
		 */
		logOutType(id,status){
			/*let ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})*/
			console.log(id)
			if(!id) return
			this.$confirm(`确定进行[${status==='1'?'注销':'取消注销'}]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/bjba/equip/type/logOutType`,
					method: 'post',
					params: {id:id,status:status}
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.searchData()
					} else if(data && data.code ==500) {
						this.$message({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}
	}
</script>
<style lang="scss" scoped>
	.bcgl {}
</style>
